// import { loadScript } from "./utils";

import { asyncPrependToContainer, makeElement } from "../utils/dom.utils";
import { log } from "../utils/loggers.utils";

// Google Tag Manager

export const LOAD_GTAG = (id: string, onLoad?: () => void) => {
  console.log("LOAD_GTAG", id);

  // Create the external Google Analytics script
  const scriptExternal = document.createElement("script");
  scriptExternal.async = true;
  scriptExternal.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;

  // Create the inline script with the gtag configuration
  const scriptInline = document.createElement("script");
  scriptInline.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){ dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', '${id}');
  `;

  // Add the scripts at the same time in the <head> important to keep both together.
  document.head.appendChild(scriptExternal);
  document.head.appendChild(scriptInline);

  // Execute the callback function (if required)
  scriptExternal.onload = () => onLoad?.();
};
